/**
 * Temporary AUTH_DEBUG dumps. Always console.warn so logger flags cannot hide them.
 * Do not log raw JWTs — sub / exp / length only.
 */

import { parseJwtPayload } from './jwtUtils';
import {
  getPinnedAccessToken,
  getPinnedOrStoredAccessToken,
} from './authTokenGuard';

export function describeToken(token: string | null | undefined): {
  present: boolean;
  length?: number;
  sub?: string | null;
  email?: string | null;
  aud?: unknown;
  expInSec?: number | null;
  iss?: string | null;
} {
  if (!token) return { present: false };
  const payload = parseJwtPayload(token);
  const now = Math.floor(Date.now() / 1000);
  return {
    present: true,
    length: token.length,
    sub: payload?.sub ?? null,
    email: payload?.email ?? null,
    aud: payload?.aud ?? null,
    expInSec: typeof payload?.exp === 'number' ? payload.exp - now : null,
    iss: payload?.iss ?? null,
  };
}

export function dumpAuthDebug(reason: string, extra: Record<string, unknown> = {}): void {
  let lsAuth: string | null = null;
  let lsId: string | null = null;
  let lsRefresh: string | null = null;
  let auth0SpaKeys: string[] = [];
  let riverAccounts: string | null = null;
  try {
    lsAuth = localStorage.getItem('authToken');
    lsId = localStorage.getItem('id_token');
    lsRefresh = localStorage.getItem('refresh_token');
    auth0SpaKeys = Object.keys(localStorage).filter(k => k.startsWith('@@auth0spajs@@'));
    riverAccounts = localStorage.getItem('river_accounts');
  } catch {
    /* ignore */
  }

  const pin = getPinnedAccessToken();
  const chosen = getPinnedOrStoredAccessToken();

  console.warn('[AUTH_DEBUG]', reason, {
    ...extra,
    pin: describeToken(pin),
    chosen: describeToken(chosen),
    lsAuthToken: describeToken(lsAuth),
    lsIdToken: describeToken(lsId),
    pinMatchesLsAuth: pin === lsAuth,
    chosenSource:
      pin && chosen === pin ? 'pin' : chosen === lsAuth ? 'localStorage.authToken' : chosen === lsId ? 'localStorage.id_token' : chosen ? 'unknown' : 'none',
    hasRefreshToken: !!lsRefresh,
    refreshTokenLength: lsRefresh?.length ?? 0,
    auth0SpaCacheKeyCount: auth0SpaKeys.length,
    auth0SpaCacheKeys: auth0SpaKeys,
    riverAccounts,
    pathname: typeof window !== 'undefined' ? window.location.pathname : null,
  });
}

if (typeof window !== 'undefined') {
  (window as unknown as { __dumpAuthDebug?: () => void }).__dumpAuthDebug = () =>
    dumpAuthDebug('manual window.__dumpAuthDebug()');
}
